// @flow
import Advertiser from 'common/modules/advertiser/domain/Advertiser';
import { BEGIN_SESSION } from 'advertisers/modules/authentication/actions/sessionActions';
import { UPDATE_ADVERTISER_NAME } from '../actions/advertiserActions';

export type AdvertiserState = {
  current?: Advertiser;
};

const INITIAL_STATE = {
  current: undefined,
};

export default function currentAdvertiserReducer(state: AdvertiserState = INITIAL_STATE, action: any) {
  switch (action.type) {
    case BEGIN_SESSION:
      return {
        ...state,
        current: action.advertiser,
      };
    case UPDATE_ADVERTISER_NAME :
      return {
        ...state,
        current: action.advertiser,
      };
    default: return state;
  }
}



// WEBPACK FOOTER //
// ./src/advertisers/modules/advertiser/reducers/advertiserReducer.js